<script setup>
const props = defineProps({
	title: String,
	division: String
})

const show_on_desktop = 'd-none d-md-flex';
const show_on_mobile = ref('d-flex d-md-none');

const baseUrl = ref('');
const navi = ref('')
const copyText = ref('Copy link')

const getMobileOS = () => {
	if (/windows phone/i.test(navigator.userAgent)) {
		return 'Windows Phone';
	}

	if (/android/i.test(navigator.userAgent)) {
		return 'Android';
	}

	if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
		return 'iOS';
	}

	return '';
}

const isMobileOS = () => {
	return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

const sendSMS = (phoneNumbers) => {
	let body = baseUrl.value
	let phoneNumbersAsStr = Array.isArray(phoneNumbers) && phoneNumbers.length > 0 ? phoneNumbers.join(',') : '';
	let smsLink = 'sms:' + phoneNumbersAsStr + (getMobileOS() === 'iOS' ? '&' : getMobileOS() === 'Android' ? '?' : '?&') + 'body=' + encodeURI(body);
	window.location.href = smsLink;
}

const sendEmail = (subject) => {
	let body = baseUrl.value
	let uri = "mailto:?subject=";
	uri += encodeURIComponent(subject);
	uri += "&body=";
	uri += encodeURIComponent(body);
	window.location.href = uri;
}

const shareLinkViaFacebook = () => {
	let link = baseUrl.value
	let uri = 'https://www.facebook.com/sharer/sharer.php?u=' + link;
	if (isMobileOS()) {
		window.location.href = uri;
		return;
	}
	window.open(uri);
}

const shareLinkViaFacebookMessenger = () => {
	let link = baseUrl.value
	window.location.href = 'fb-messenger://share?link=' + encodeURIComponent(link) + '&app_id=' + config['facebook-app-id'];
}

const shareLinkViaWhatsApp = () => {
	let link = baseUrl.value
	let uri = 'https://api.whatsapp.com/send?text=' + link;

	if (isMobileOS()) {
		uri = 'whatsapp://send?text=' + link;
		window.location.href = uri;
		return;
	}

	window.open(uri);
}

const shareArticleOnLinkedIn = (title, summary) => {
	let url = baseUrl.value
	let source = baseUrl.value
	let link = "https://www.linkedin.com/shareArticle";
	link += '?mini=true';
	link += '&url=' + encodeURIComponent(url);

	if (title.length && title.length > 1) { link += '&title=' + encodeURIComponent(title); }
	if (summary.length && summary.length > 1) { link += '&summary=' + encodeURIComponent(summary); }
	if (source.length && source.length > 1) { link += '&source=' + encodeURIComponent(source); }

	if (isMobileOS()) {
		window.location.href = link;
		return;
	}

	window.open(link);
}

async function copyToClipboard() {
	try {
		await navigator.clipboard.writeText(baseUrl.value);
		copyText.value = 'Copied link!'
	} catch (error) {
		fallbackCopyToClipboard(baseUrl.value)
	}
}

function fallbackCopyToClipboard(text) {
	const textarea = document.createElement('textarea')
	textarea.value = text
	document.body.appendChild(textarea)
	textarea.select()
	document.execCommand('copy')
	document.body.removeChild(textarea)
	copyText.value = 'Copied link!'
}

const shareArticleOnTwitter = () => {
  let uri = `http://twitter.com/share?text=${baseUrl.value}`
  window.open(uri);
}

onMounted(() => {
	baseUrl.value = window.location.href;

	// const base = document.querySelector('base');
	// if (base && base.href) {
	// 	baseUrl.value = base.href;
	// } else {
	// 	baseUrl.value = window.location.origin;
	// }
	// navi.value = navigator
})
</script>

<template>
  <div class="d-flex px-2 pb-2 pb-md-0 mb-2 justify-content-center align-items-center heading">
		<p class="px-2 mb-0 font-weight-normal"><b class="pe-2">Share</b><span v-if="title"> {{ title }}</span><span v-if="division"> - {{ division }}</span></p>
	</div>
	<div class="my-2 d-flex flex-column justify-content-between link-container">
		<div class="d-flex flex-column flex-sm-row link-wrapper">
			<a class="social-share__link social-share__link--email" @click="sendEmail('')">
				<span class="social-share__link__icon social-share__link__icon--email icon-email"></span>
				<span class="social-share__link__text">Email</span>
			</a>
			<a class="social-share__link social-share__link--copy-link" @click="copyToClipboard" :class="show_on_desktop" v-html="copyText"></a>
			<a class="social-share__link social-share__link--sms" @click="sendSMS([])" :class="show_on_mobile">
				<span class="social-share__link__icon social-share__link__icon--sms icon-sms"></span>
				<span class="social-share__link__text">SMS</span>
			</a>
		</div>
		<div :class="show_on_desktop" class="flex-column flex-sm-row link-wrapper">
			<a class="social-share__link social-share__link--facebook" @click="shareLinkViaFacebook">
				<span class="social-share__link__icon icon-facebook-circle"></span>
				<span class="social-share__link__text">Facebook</span>
			</a>
			<a class="social-share__link social-share__link--linkedin" @click="shareArticleOnLinkedIn('', '');">
				<span class="social-share__link__icon icon-linkedin-square"></span>
				<span class="social-share__link__text">LinkedIn</span>
			</a>
		</div>
		<div :class="show_on_mobile" class="flex-column flex-sm-row link-wrapper">
			<a class="social-share__link social-share__link--copy-link" @click="copyToClipboard" v-html="copyText"></a>
			<a class="social-share__link social-share__link--messenger" @click="shareLinkViaFacebookMessenger">
				<span class="social-share__link__icon icon-messenger"></span>
				<span class="social-share__link__text">Messenger</span>
			</a>
		</div>
		<div class="d-flex flex-column flex-sm-row link-wrapper">
			<a class="social-share__link social-share__link--facebook" @click="shareLinkViaFacebook" :class="show_on_mobile">
				<span class="social-share__link__icon icon-facebook-circle"></span>
				<span class="social-share__link__text">Facebook</span>
			</a>
			<a class="social-share__link social-share__link--whatsapp" @click="shareLinkViaWhatsApp">
				<span class="social-share__link__icon icon-whatsapp"></span>
				<span class="social-share__link__text">WhatsApp</span>
			</a>
			<a class="social-share__link social-share__link--twitter" @click="shareArticleOnTwitter" :class="show_on_desktop">
				<span class="social-share__link__icon bi bi-twitter-x"></span>
				<span class="social-share__link__text">X</span>
    		</a>
		</div>
		<div :class="show_on_mobile" class="flex-column flex-sm-row link-wrapper">
			<a class="social-share__link social-share__link--linkedin" @click="shareArticleOnLinkedIn('', '');">
				<span class="social-share__link__icon icon-linkedin-square"></span>
				<span class="social-share__link__text">LinkedIn</span>
			</a>
			<a class="social-share__link social-share__link--twitter" @click="shareArticleOnTwitter">
				<span class="social-share__link__icon bi bi-twitter-x"></span>
				<span class="social-share__link__text">X</span>
    		</a>
		</div>
	</div>
</template>


<style lang="scss" scoped>
	.heading {
			
		@include media-breakpoint-down(md) {
				border-bottom: 1px solid #e4e4e4;
		}
			
		&::before {
				display: inline-block;
				content: '';
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='44' height='44' viewBox='0 0 44 44'%3E%3Cdefs%3E%3ClinearGradient id='linear-gradient' x1='.043' x2='.969' y1='.5' y2='.5' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%2365c573'/%3E%3Cstop offset='1' stop-color='%2344ae9c'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cpath id='share_univeral_icon' fill='url(%23linear-gradient)' d='M-82.5 10687a21.88 21.88 0 0 1-8.563-1.729 21.931 21.931 0 0 1-6.992-4.715 21.924 21.924 0 0 1-4.714-6.993 21.873 21.873 0 0 1-1.731-8.563 21.86 21.86 0 0 1 1.729-8.562 21.931 21.931 0 0 1 4.714-6.994 21.941 21.941 0 0 1 6.992-4.714 21.88 21.88 0 0 1 8.565-1.73 21.883 21.883 0 0 1 8.563 1.729 21.945 21.945 0 0 1 6.993 4.714 21.932 21.932 0 0 1 4.715 6.994A21.855 21.855 0 0 1-60.5 10665a21.868 21.868 0 0 1-1.729 8.564 21.925 21.925 0 0 1-4.715 6.993 21.935 21.935 0 0 1-6.993 4.715A21.883 21.883 0 0 1-82.5 10687zm-8.158-25.351a1.443 1.443 0 0 0-.967.354l-3.664 3.3a1.474 1.474 0 0 0-.491 1.1 1.478 1.478 0 0 0 .491 1.1l12.091 10.99a1.8 1.8 0 0 0 1.21.448 1.8 1.8 0 0 0 1.21-.448l12.091-10.99a1.44 1.44 0 0 0 .547-1.1 1.44 1.44 0 0 0-.513-1.1l-3.629-3.3a1.446 1.446 0 0 0-.967-.354 1.446 1.446 0 0 0-.967.354 1.191 1.191 0 0 0-.388.879 1.189 1.189 0 0 0 .388.878l2.175 1.979a.894.894 0 0 1 .312.66.893.893 0 0 1-.312.659l-9.189 8.353a1.072 1.072 0 0 1-.724.283 1.072 1.072 0 0 1-.724-.283l-9.191-8.353a.9.9 0 0 1-.31-.659.9.9 0 0 1 .31-.66l2.178-1.979a1.189 1.189 0 0 0 .388-.878 1.191 1.191 0 0 0-.388-.879 1.443 1.443 0 0 0-.967-.354zm7.323-5.614v7.223a1.325 1.325 0 0 0 1.381 1.256 1.325 1.325 0 0 0 1.381-1.256v-7.223l1.9 1.915a1.33 1.33 0 0 0 .932.377 1.33 1.33 0 0 0 .932-.377 1.232 1.232 0 0 0 .388-.907 1.17 1.17 0 0 0-.388-.853l-3.972-3.768a1.692 1.692 0 0 0-1.175-.471 1.692 1.692 0 0 0-1.175.471l-3.972 3.768a1.24 1.24 0 0 0-.388.912 1.167 1.167 0 0 0 .388.848 1.4 1.4 0 0 0 .947.365 1.31 1.31 0 0 0 .917-.365l1.9-1.914z' data-name='share univeral icon' transform='translate(104.499 -10643)'/%3E%3C/svg%3E%0A");
				min-width: 44px;
				min-height: 44px;
				background-repeat: no-repeat;
				margin-right: .5rem;
		}

		p:first-of-type {
				font-size: 1.25rem;
				color: black;
		}
	}

	.social-share {

		@include media-breakpoint-down(md) {
			width: 100%;
			flex-direction: row-reverse;
			justify-content: space-between;
			border-bottom: 1px solid #e4e4e4;
			padding-left: 0;
			padding-right: 0;
		}

		&__link {
			color: black;
			width: 50%;
			margin: .2rem;
			text-decoration: none;
			
			&:hover {

				&::before {
					filter: opacity(1);
				}

				.social-share__link__icon {
					color: black;
				}
			}

			&::before {
				filter: opacity(0.65);
				-webkit-transition: .25s -webkit-filter linear;
				-moz-transition: .25s -moz-filter linear;
				-moz-transition: .25s filter linear;
				-ms-transition: .25s -ms-filter linear;
				-o-transition: .25s -o-filter linear;
				transition: .25s filter linear, .25s -webkit-filter linear;
			}
				
			&__text {
				&:hover {
					text-decoration: underline;
				}
			}

			&__icon {
				font-size: 1.75rem;
				margin-right: 1rem;
				color: #4c4c4c;

				&--email {
					font-size: 1.5rem;
				}

				&--sms {
					&::before {
						display: block;
						content: '';
						width: 30px;
						height: 30px;
						filter: contrast(45%);
						background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='32' height='32' viewBox='0 0 140 140' xml:space='preserve'%3E%3Cdefs%3E%3C/defs%3E%3Cg transform='matrix(1 0 0 1 64 64)' id='tl1z2V1Rx48nItHhqETtZ'%3E%3Cpath style='stroke: rgb(0,0,0); stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;' vector-effect='non-scaling-stroke' transform=' translate(0, 0)' d='M 64 -64 L 64 36.787409999999994 L -23.685010000000005 36.787409999999994 L -64 63.99999999999999 L -64 -64 z M -4.03147 -8.06304 L 12.0945 -8.06304 L 12.0945 -24.18901 L -4.031469999999999 -24.18901 z M 26.20469 -8.06304 L 42.330659999999995 -8.06304 L 42.330659999999995 -24.18901 L 26.204689999999996 -24.18901 z M -34.26773 -8.06304 L -18.14176 -8.06304 L -18.14176 -24.18901 L -34.26773 -24.18901 z' stroke-linecap='round'/%3E%3C/g%3E%3C/svg%3E");
					}
				}
			}
		}
	}

	.link-wrapper {
		&:last-of-type {
			.social-share__link:last-of-type {
				@include media-breakpoint-down(md) {
					border-bottom: none;
				}
			}
		}
	}

	.social-share {
		&__link {
			display: flex;
			align-items: center;
			cursor: pointer;
			padding: .5rem;

			&--copy-link {

				&:hover {
						text-decoration: underline !important;
				}

				&::before {
						background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30.295' height='30.268' viewBox='0 0 30.295 30.268'%3E%3Cdefs%3E%3Cstyle%3E .prefix__cls-1%7Bfill:none;stroke:%23000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px%7D %3C/style%3E%3C/defs%3E%3Cg id='prefix__copy_link_icon' data-name='copy link icon' transform='translate(1.5 1.5)'%3E%3Cpath id='prefix__Path_432' d='M15 18.005a6.82 6.82 0 0 0 10.285.737l4.092-4.092a6.82 6.82 0 1 0-9.645-9.645l-2.345 2.333' class='prefix__cls-1' data-name='Path 432' transform='translate(-4.081 -3.008)'/%3E%3Cpath id='prefix__Path_433' d='M19.368 16.227a6.82 6.82 0 0 0-10.285-.737l-4.092 4.093a6.82 6.82 0 1 0 9.645 9.645l2.332-2.333' class='prefix__cls-1' data-name='Path 433' transform='translate(-2.993 -3.958)'/%3E%3C/g%3E%3C/svg%3E%0A");
				}

				&::before {
					content: '';
					margin-right: 1rem;
					background-repeat: no-repeat;
					background-position: center center;
					min-width: 32px;
					min-height: 32px;
					background-size: auto;
				}
			}
		}
	}
</style>
           
